<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router'

  import { computed, ref } from 'vue'

  import ManagerButton from '@/components/Global/Manager/Forms/ManagerButton.vue'

  const props = withDefaults(
    defineProps<{
      link?: RouteLocationRaw
      color?: string
      disabled?: boolean
      btnClasses?: string

      iconColor?: string
      hoveredIconColor?: string

      ariaLabel?: string
    }>(),
    {
      link: '',
      btnClasses: 'p-3 !w-8 !h-8',
      color: 'white',
      disabled: false,

      iconColor: 'black',
      hoveredIconColor: '#7a7a7a',

      ariaLabel: undefined,
    }
  )

  const isHover = ref(false)

  const iconColor = computed(() =>
    isHover.value ? props.hoveredIconColor : props.iconColor
  )
</script>

<template>
  <ManagerButton
    class="rounded-full !h-auto"
    v-bind="props"
    :aria-label="props.ariaLabel"
    @mouseover="isHover = true"
    @mouseout="isHover = false"
  >
    <slot :icon-color="iconColor" />
  </ManagerButton>
</template>
